import React from 'react';
import Menu from '@mui/material/Menu';
import SvgLoginOut from './SvgLoginOut';
import { AuthContext } from '@/context/create-context';
import { HOME_PAGE_ROUTER_PATH } from '@/constants/router-path';

const Logout = () => {
  const { logout } = React.useContext(AuthContext);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    const isOk = await logout();
    if (isOk) {
      window.location.href = HOME_PAGE_ROUTER_PATH;
    }
  };
  return (
    <>
      <span className="cursor-pointer" onClick={handleClick}>
        <SvgLoginOut />
      </span>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        slotProps={{
          paper: {
            sx: {
              '.MuiList-root': {
                padding: 0,
              },
            },
          },
        }}
      >
        <li
          className="px-9 py-4 text-sm whitespace-nowrap cursor-pointer text-center hover:bg-slate-100"
          onClick={handleLogout}
        >
          退出登录
        </li>
      </Menu>
    </>
  );
};

export default Logout;
